import { connect } from "react-redux";
import get from "lodash/get";

import {
  getServiceHistory as onGetServiceHistory,
  createServiceHistoryComment as onCreateServiceHistoryComment,
  getServiceHistoryActions as onGetServiceHistoryActions,
} from "../../actions/serviceHistoryActions";

const mapStateToProps = (state) => ({
  serviceHistoryDataState: state.serviceHistory.dataState,
  serviceHistoryActionsDataState: state.serviceHistory.serviceHistoryActionsDataState,
  createServiceHistoryCommentDataState: state.serviceHistory.createServiceHistoryCommentDataState,
  serviceHistory: get(state, ["serviceHistory", "serviceHistory"], null),
  serviceHistoryTotalCount: get(state, ["serviceHistory", "serviceHistoryTotalCount"], 0),
  serviceHistoryCount: get(state, ["serviceHistory", "serviceHistoryCount"], 0),
  serviceHistoryActions: get(state, ["serviceHistory", "serviceHistoryActions"], []),
});

const mapDispatchToProps = { onGetServiceHistory, onCreateServiceHistoryComment, onGetServiceHistoryActions };

const withServiceHistory = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withServiceHistory };
